import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Fotter from "./Fotter";
import SettingSidebar from "./SettingSidebar";
import { Link, useParams } from "react-router-dom";
import Cookies from "js-cookie";
import { BASE_URL } from "../Pages/Config";
import BuyerName from "../components/BuyerNameRewview";
import Swal from "sweetalert2";

import "../components/SettingChargesDetail.css";

export default function SettingChargesDetail() {
  const [charges, setCharges] = useState([]);
  const [loading, setLoading] = useState(true);
  const user_id = Cookies.get("user_id");
  const { id } = useParams();

  const fetchCharges = async () => {
    try {
      setLoading(true);
      const res = await fetch(
        `${BASE_URL}/get_user_charges.php?type=single&charges_id=${id}&t=${Date.now()}`,
        { cache: "no-store" }
      );
      const data = await res.json();
      if (data.success) setCharges(data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchCharges();
  }, [id]);

  const payCharges = async (chargeId) => {
    try {
      setLoading(true);
      const res = await fetch(
        `${BASE_URL}/pay_charges_single.php?charge_id=${chargeId}&user_id=${user_id}`
      );
      const data = await res.json();
      Swal.fire({
        icon: data.success ? "success" : "error",
        title: data.success ? "Payment Updated" : "Oops...",
        text: data.message || "Something went wrong.",
      });
      fetchCharges();
    } catch (err) {
      console.error(err);
      Swal.fire({ icon: "error", title: "Error", text: "Payment failed." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />

      <div className="page-info">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="info">
                <Link to="/">HOME</Link> / <Link to="/">FASTTRADE</Link> /
                Charges
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-settings">
        <div className="container">
          <div className="row">
            <SettingSidebar />
            <div className="col-md-8">
              {loading ? (
                <p>Loading charges...</p>
              ) : charges.length === 0 ? (
                <p className="no-charges">No charges available yet.</p>
              ) : (
                charges.map((item) => {
                  const isSeller =
                    parseInt(user_id) === parseInt(item.seller_id);
                  const statusValue = isSeller
                    ? item.charges_paid_status_seller
                    : item.charges_paid_status_buyer;
                  const isPaid = statusValue?.toLowerCase() === "paid";

                  return (
                    <div key={item.charge_id} className="receipt-card">
                      <div className="receipt-header">
                        <h3>Charge Detail</h3>
                        <p>#{item.product_id}</p>
                      </div>

                      <div className="receipt-body">
                        {/* Product Info */}
                        <div className="product-infos">
                          <img
                            src={`${BASE_URL}/${
                              item.photo?.split(",")[0] ||
                              "/uploads/logo/icon.png"
                            }`}
                            alt={item.title || "Product"}
                          />
                          <div>
                            <h4>{item.title}</h4>
                            <p>
                              Price:{" "}
                              <strong>
                                {item.buy_product_status === 0
                                  ? item.current_price
                                  : item.buy_now}{" "}
                                SAR
                              </strong>
                            </p>
                          </div>
                        </div>

                        <div style={{ display: "flex" }}>
                          {/* User Info */}
                          <div className="user-info" style={{ width: "50%" }}>
                            <p>
                              Seller:{" "}
                              <strong>
                                <BuyerName buyerId={item.seller_id} />
                              </strong>
                            </p>
                            <p>
                              Buyer:{" "}
                              <strong>
                                <BuyerName buyerId={item.buyer_id} />
                              </strong>
                            </p>
                            <p>
                              Charges:{" "}
                              <p>
                                <strong>
                                  {parseInt(user_id) ===
                                  parseInt(item.seller_id)
                                    ? item.seller_charge
                                    : item.buyer_charge}{" "}
                                  SAR
                                </strong>
                              </p>
                            </p>
                            <p>
                              Status:{" "}
                              <span className={isPaid ? "paid" : "pending"}>
                                {statusValue}
                              </span>
                            </p>
                          </div>

                          {/* Purchase / Auction Details */}
                          <div
                            className="purchase-info"
                            style={{ width: "50%" }}
                          >
                            <p>
                              Location:{" "}
                              <p>
                                <strong>
                                  {item.location}, {item.city}{" "}
                                  {item.neighborhood
                                    ? `(${item.neighborhood})`
                                    : ""}
                                </strong>
                              </p>
                            </p>

                            <p>
                              Shipping:{" "}
                              <p>
                                <strong>
                                  {item.shipping || "Not specified"}
                                </strong>
                              </p>
                            </p>
                          </div>
                        </div>

                        {/* Payment Actions */}
                        {!isPaid && (
                          <div className="receipt-actions">
                            <button
                              className="btn-pay"
                              onClick={() => payCharges(item.id)}
                            >
                              Pay Charges
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>
      </div>

      <Fotter />
    </>
  );
}
